import React from 'react';
import {
  FaUser,
  FaSignOutAlt,
  FaStar,
  FaExternalLinkAlt,
  FaEdit,
} from 'react-icons/fa';
import UserCardHeader from './UserCardHeader';
import UserDetails from './UserDetails';
import '../../styles/Home.css';

export default function SpotifyUserCard({
  user,
  onNavigateProfile,
  onLogout,
  onEdit,
  isAppCard,
  appData,
}) {
  if (!user) {
    return null;
  }

  const details = [
    { label: "Nom d'affichage", value: user.display_name || 'Non défini' },
    ...(user.email ? [{ label: 'Email', value: user.email }] : []),
    { label: 'ID', value: user.id },
    ...(user.country ? [{ label: 'Pays', value: user.country }] : []),
    ...(user.product
      ? [
          {
            label: 'Abonnement',
            value:
              user.product === 'premium'
                ? 'Premium'
                : user.product === 'free'
                ? 'Gratuit'
                : user.product,
            icon: user.product === 'premium' ? FaStar : null,
          },
        ]
      : []),
    ...(user.followers !== undefined
      ? [
          {
            label: 'Abonnés',
            value: (user.followers?.total ?? user.followers).toLocaleString(),
          },
        ]
      : []),
    ...(user.external_urls?.spotify
      ? [
          {
            label: 'Profil Spotify',
            value: (
              <a
                href={user.external_urls.spotify}
                target="_blank"
                rel="noopener noreferrer"
                className="spotify-profile-link"
              >
                Voir sur Spotify <FaExternalLinkAlt size={10} />
              </a>
            ),
          },
        ]
      : []),
  ];

  return (
    <div className="card fade-in user-card spotify-card">
      <UserCardHeader
        user={user}
        platform="Spotify"
        avatarUrl={user.images?.[0]?.url}
        avatarAlt={user.display_name || user.id}
      />
      <div className="section">
        <UserDetails details={details} />
        <div className="user-actions">
          {isAppCard && onEdit && (
            <button
              className="user-action-btn edit"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                onEdit();
              }}
              title="Modifier l'application"
            >
              <FaEdit /> Modifier
            </button>
          )}
          <button
            className="user-action-btn spotify"
            onClick={() => onNavigateProfile('spotify')}
          >
            <FaUser /> Profil
          </button>
          <button
            className="user-action-btn secondary"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onLogout();
            }}
          >
            <FaSignOutAlt /> Déconnexion
          </button>
        </div>
      </div>
    </div>
  );
}
